import { InventoryTagStatus, TagType } from '@rematter/frontend-lib-api-client';

import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableInventoryTags = QueryHookResult<
  typeof useInventoryTagsQuery
>[number];

export const useInventoryTagsQuery = createQueryHook(
  'shared.inventoryTags',
  (params: {
    searchTerm?: string;
    tagNumbers?: string[];
    tagTypes?: TagType[];
    statuses?: InventoryTagStatus[];
    ids?: string[];
    facilityIds?: string[];
    isRevised?: boolean;
    limit?: number;
    offset?: number;
  }) => ({
    inventoryTags: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          tagNumbers: params.tagNumbers,
          tagTypes: params.tagTypes,
          statuses: params.statuses,
          ids: params.ids,
          facilityIds: params.facilityIds,
          isRevised: params.isRevised,
        },
        pagination: {
          limit: params.limit ?? 20,
          offset: params.offset ?? 0,
        },
      },
      page: {
        total: true,
        offset: true,
        limit: true,
      },
      entries: {
        id: true,
        tagNumber: true,
        tagType: true,
        status: true,
        grossQuantity: true,
        tare: true,
        netQuantity: true,
        item: {
          id: true,
          name: true,
          skuNumber: true,
          effectivePricingUnit: true,
        },
        isRevised: true,
        quantityCaptureMethod: true,
        tareCaptureMethod: true,
      },
    },
  }),
  {
    select: (data) =>
      data?.inventoryTags.entries?.map((item) => ({
        id: item.id,
        tagNumber: item.tagNumber,
        grossQuantity: item.grossQuantity,
        tare: item.tare,
        netQuantity: item.netQuantity,
        inventoryItem: item.item.name,
        item: {
          id: item.item.id,
          name: item.item.name,
          effectivePricingUnit: item.item.effectivePricingUnit,
        },
        metadata: item,
      })) ?? [],
  },
);

export const SelectInventoryTagTouch = createEntityTouchSelect.remotelySearched(
  'SelectInventoryTags',
  useInventoryTagsQuery,
  {
    formatLabel: (entity) => `#${entity.tagNumber}`,
    formatSubLabel: (entity) => entity.inventoryItem,
  },
);
